import { styled } from '@linaria/react';
import { memo } from 'react';
import { ViewMode } from '../../../constants/enums';
import { generateModalKey } from '../../../state/internal/modals';
import dynamicWithRetry, { loadWithRetry } from '../../../utilities/dynamicWithRetry';
import { useFloaters, useFloatingRoomId, useFloatingRoomStateSelector } from '../../Hooks/useModal';
import { usePassive } from '../../Hooks/usePassive';
import { useRouteSelector } from '../../Hooks/useRoute';
import { useScreenStateSelector } from '../../Hooks/useScreenState';
import "./Floaters.linaria.module.css!=!./Floaters?./Floaters.linaria.module.css?css=H4sIAAAAAAAAA03IMQ6AIAxA0d17mOiAwRVOg0Ckiq2Bokbj3Y1xcfvvd9zTgucUr5UyMBAqM2SKhb0ejJ3HRAWdsBQpqc2kRojf5mQwx2I9cqt3cBxUL2Wtg4cx8NenAHT+eCH1XT2xUTxscQAAAA=="
loadWithRetry(() => import('../Modals/Floater')).catch(() => undefined);
const Floater = dynamicWithRetry(() => import('../Modals/Floater'));
loadWithRetry(() => import('../Modals/QuickMenu')).catch(() => undefined);
const QuickMenu = dynamicWithRetry(() => import('../Modals/QuickMenu'));
interface FloaterLayoutProps {
  isMobile: boolean;
}
const TransitionCover = /*#__PURE__*/styled('div')({
  name: "TransitionCover",
  class: "t1omnzjl",
  propsAsIs: false
});
const Floaters = (props: FloaterLayoutProps) => {
  const {
    isMobile
  } = props;
  const floaters = useFloaters();
  const floatingRoomId = useFloatingRoomId();
  const calculated = useScreenStateSelector('calculated');
  const portrait = useScreenStateSelector('portrait');
  const viewMode = useFloatingRoomStateSelector('viewMode');
  const fullWindow = viewMode === ViewMode.FullWindow;
  const passiveMode = usePassive();
  const FloatingPage = useRouteSelector('floatingComponent');

  // TODO: it may be possible to get rid of the floating_room modal object?
  // const floatingRoomId = useRouteSelector('slugID')
  return <>
            {floatingRoomId && passiveMode && fullWindow && <TransitionCover id="transition-cover" />}
            {floaters.map(floater => <Floater vertical={portrait} fullWindow={fullWindow} isMobile={isMobile} floaterType={floater.type} floaterID={floater.id} key={generateModalKey(floater.type, floater.id)} />)}
            {floatingRoomId && calculated && <FloatingPage fullWindow={fullWindow} isMobile={isMobile} vertical={portrait} />}
            <QuickMenu />
        </>;
};
export default memo(Floaters);